import React, { HTMLAttributes } from "react";
import { ColumnSizeProps } from "../../types";
import { CardPaddingSize } from "./types";
import { CardStatus, CardStatusProps } from "./CardStatus";
import { useCardProps } from "./useCardProps";

export type CardProps = HTMLAttributes<HTMLDivElement> &
  ColumnSizeProps & {
    active?: boolean;
    padding?: CardPaddingSize;
    stacked?: boolean;
    status?: CardStatusProps;
  };

export const Card = (props: CardProps) => {
  const { children, status, ...rest } = useCardProps(props);

  return (
    <div {...rest}>
      {status && <CardStatus {...status} />}
      {children}
    </div>
  );
};

export default Card;
